import i18n from 'modules/core/lib/i18n'
import { StatusVariant } from '@factorialco/f0-react'
import {
  ExpensesEntitiesExpensableStatusEnum,
  FinanceValueObjectsBudgetMovementStatusEnum,
} from 'generated/resources/graphql'

export const paymentStatusVariant = (
  status: FinanceValueObjectsBudgetMovementStatusEnum
): StatusVariant => {
  switch (status) {
    case 'draft':
      return 'neutral'
    case 'pending':
      return 'warning'
    case 'spent':
      return 'positive'
    case 'rejected':
      return 'critical'
    default:
      return 'neutral'
  }
}

export const paymentStatusLabel = (status: FinanceValueObjectsBudgetMovementStatusEnum): string => {
  switch (status) {
    case 'draft':
      return i18n.t('budgets.budget_movement_status.draft')
    case 'pending':
      return i18n.t('budgets.budget_movement_status.pending')
    case 'spent':
      return i18n.t('budgets.budget_movement_status.spent')
    case 'rejected':
      return i18n.t('budgets.budget_movement_status.rejected')
  }
}

export const expenseStatusVariant = (
  status: ExpensesEntitiesExpensableStatusEnum
): StatusVariant => {
  switch (status) {
    case 'draft':
    case 'reversed':
      return 'neutral'
    case 'pending':
    case 'changes_requested':
      return 'warning'
    case 'approved':
    case 'in_payroll':
    case 'sent_to_pay':
    case 'paid':
      return 'positive'
    case 'rejected':
      return 'critical'
    default:
      return 'neutral'
  }
}

export const expenseStatusLabel = (status: ExpensesEntitiesExpensableStatusEnum): string => {
  const statuses: Record<ExpensesEntitiesExpensableStatusEnum, string> = {
    reversed: i18n.t('expenses_v2.expense.status.reversed'),
    draft: i18n.t('expenses_v2.expense.status.draft'),
    approved: i18n.t('expenses_v2.expense.status.approved'),
    pending: i18n.t('expenses_v2.expense.status.pending'),
    rejected: i18n.t('expenses_v2.expense.status.rejected'),
    in_payroll: i18n.t('expenses_v2.expense.status.inPayroll'),
    sent_to_pay: i18n.t('expenses_v2.expense.status.sentToPay'),
    paid: i18n.t('expenses_v2.expense.status.paid'),
    changes_requested: i18n.t('expenses_v2.expense.status.changesRequested'),
  }
  return statuses[status] ?? ''
}
